var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import { useState, useEffect } from 'react';
import qs from 'query-string';
export var formatDesignPageUrl = function formatDesignPageUrl(themeId, type, from) {
  if (type === void 0) {
    type = 'design';
  }
  var query = qs.parse(location.search);
  return "/themes/" + type + "/" + themeId + "?from=" + encodeURIComponent(from || query.from || "" + location.pathname + location.search);
};
export default function useBreadcrumb() {
  var _a = __read(useState(''), 2),
    url = _a[0],
    setUrl = _a[1];
  useEffect(function () {
    var query = qs.parse(location.search);
    var url = query.from;
    if (url) {
      setUrl(url);
    }
  }, []);
  return {
    fromUrl: url
  };
}